import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import { NavBar } from "./components/NavBar";
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { Preloader } from "./components/Preloader";
import ChatBot from "./components/ChatBot";
import { CareerTimeline } from "./components/CareerTimeline";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
  return (
    <div className="App">
      {loading ? (
        <Preloader />
      ) : (
        <>
          <NavBar />
          <Banner />
          <Skills />
          <CareerTimeline />
          <Projects />
          <Contact />
          <Footer />
          <ChatBot />
        </>
      )}
    </div>
  );
}

export default App;
